export default "__VITE_ASSET__BxB1tPE___"